export default __webpack_public_path__ + "static/media/play-button.2ab4dbaa.png";